export const bladePatternGuide = {
  padding: "30px",
};

export const pattern = {
  padding: "20px 0",
  borderBottom: "solid 1px",
  borderColor: "grey9",

  "&:last-of-type": {
    borderBottom: "none",
    paddingBottom: "0",
  },
};

export const titleContainer = {
  display: "flex",
  justifyContent: "space-between",
};

export const descriptionContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
});

export const imagesContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "row" : "column",
  flexGrow: 0,
  flexShrink: 0,
  ml: isMobile ? "-5px" : "0",
  mr: isMobile ? "-5px" : "20px",

  mt: isMobile ? "0" : "-5px",
  mb: isMobile ? "20px" : "15px",
});

export const image = ({ isMobile }) => ({
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 50%",
  borderRadius: "100000px",
  border: "solid 1px",
  borderColor: "grey5",
  mx: isMobile ? "5px" : "0",
  my: isMobile ? "0" : "5px",
  height: "60px",
  width: "60px",
});

export const details = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  mx: isMobile ? "0" : "-1px",
});

export const detailsItem = ({ isMobile }) => ({
  backgroundColor: "grey9",
  padding: isMobile ? "10px" : "15px",
  mx: isMobile ? "0" : "1px",
  marginBottom: isMobile ? "2px" : "0",

  "&:last-of-type": {
    marginBottom: "0",
  },

  "> *": {
    display: isMobile ? "inline" : "block",
  },
});

export const detailsTitle = ({ isMobile }) => ({
  mb: isMobile ? "0" : "10px",
});
